/**
 * Create a WeakMap with a Map fallback for environments that lack WeakMap.
 */
export function createWeakMap<K extends WeakKey, V>(): WeakMap<K, V> {
  if (typeof WeakMap === 'function') {
    return new WeakMap<K, V>()
  }
  return new Map<K, V>()
}
